import { isEmpty } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useDeepCompareEffect } from 'react-use';
import { useIsScratchpadInPlaylist } from '../../../../components/machine/playlist/scratchpad-playlist.hooks';
import { useScratchpadServiceContext } from '../../../../components/machine/scratchpad/scratchpad-service-context-provider';
import { sleep } from '../../../../util/async';

const usePersistedSelectedFlowItemIds = (itemIds: string[]): string[] => {
  const [previous, setPrevious] = useState<string[]>(itemIds);

  useDeepCompareEffect(() => {
    if (!isEmpty(itemIds)) {
      setPrevious(itemIds);
    }
  }, [itemIds]);

  return previous;
};

const useShowPlaylistOptions = (
  enabled = true,
  showPlaylistOptions: () => void
): ((forceShow?: boolean) => void) => {
  const { scratchpad } = useScratchpadServiceContext();

  const isScratchpadInPlaylist = useIsScratchpadInPlaylist(scratchpad.id);

  const [hasShownOptions, setHasShownOptions] = useState<boolean>(false);

  useEffect(() => {
    if (scratchpad.id) {
      setHasShownOptions(false);
    }
  }, [scratchpad.id]);

  const showOptionsIfFirstTimeTeaching = useCallback(
    async (forceShow?: boolean) => {
      if (
        forceShow ||
        (enabled && !hasShownOptions && !isScratchpadInPlaylist)
      ) {
        // wait for panel to dismiss before showing options
        await sleep(700);
        showPlaylistOptions();
        setHasShownOptions(true);
      }
    },
    [enabled, hasShownOptions, isScratchpadInPlaylist, showPlaylistOptions]
  );

  return showOptionsIfFirstTimeTeaching;
};

export { usePersistedSelectedFlowItemIds, useShowPlaylistOptions };
